import { RefObject, useEffect } from "react";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

export const useR2BInView = (
  targetRef: RefObject<HTMLElement | null>,
  enabled = true,
) => {
  useEffect(() => {
    const target = targetRef.current;
    if (!enabled || !target || typeof IntersectionObserver === "undefined") {
      return;
    }

    let hasTrackedInView = false;
    const observer = new IntersectionObserver((entries) => {
      if (
        !hasTrackedInView &&
        entries.some((entry) => entry.target === target && entry.isIntersecting)
      ) {
        hasTrackedInView = true;
        dispatchMonetateQEvent("WPDP | Reason to buy | In view");
        observer.unobserve(target);
      }
    });

    observer.observe(target);
    return () => observer.disconnect();
  }, [enabled, targetRef]);
};
